import { AccountCreated } from '@components/RouteComponents'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_initialized/accountCreated')({
  component: () => <AccountCreated />,
})
